/* eslint-disable */
// import external dependencies
import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'fullpage.js/dist/jquery.fullpage';

// import libs
import './lib/jquery.event.move';
import './lib/jquery.twentytwenty';

import 'jquery.cookie/jquery.cookie';

// import local dependencies
import Router from './util/router';
import common from './routes/Common';
import home from './routes/Home';
import aboutUs from './routes/About';

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
const routes = {
  // All pages
  common,
  // Home page
  home,
  // About us page, note the change from about-us to aboutUs.
  aboutUs,
};

// Load Events
document.addEventListener('DOMContentLoaded', () => new Router(routes).loadEvents());

// Main menu toggle submenus
function mainMenuToggle() {
  $('.menu-item-has-children').on('mouseenter', function doMenuOn() {
    $(this).children('.sub-menu').addClass('active');
    $(this).addClass('js-active');
  });

  $('.menu-item-has-children').on('mouseleave', function doMenuOn() {
    $(this).children('.sub-menu').removeClass('active');
    $(this).removeClass('js-active');
  });
}

// Change photos in comparer
// file name structure: skinColor_shirtColor_variant.jpg
// For example: black_gunmetal_good.jpg

var skin = 'black', // Default skin color
    shirt = 'gunmetal', // Default shirt color
    fileName = skin + '_' + shirt; // Default file name (e.g. black_gunmetal(_good/bad.jpg))

// function changeComparerPhotos() {
//   $('.js-toggle').on('click', function changePhotos() {
//
//     var whatChanged = $(this).data('toggle');
//
//     if(whatChanged == 'skin') {
//       skin = $(this).data('skin');
//       $('.js-toggle.size--bigger').removeClass('active');
//     } else if (whatChanged == 'shirt') {
//       shirt = $(this).data('shirt');
//       $('.js-toggle.size--normal').removeClass('active');
//     }
//
//     $(this).addClass('active');
//
//     fileName = skin + '_' + shirt;
//     setNames(fileName);
//   });
// }

function temporaryComparer() {
  $('.js-toggle.size--bigger').on('click', function () {
    var clickedOne = $(this).index();
        skin = $(this).data('skin');
        shirt = $('.js-toggle.size--normal').eq(clickedOne).data('shirt');

    $('.js-toggle').removeClass('active');
    $(this).addClass('active');
    $('.js-toggle.size--normal').eq(clickedOne).addClass('active');

    fileName = skin + '_' + shirt;
    setNames(fileName);
  });
}

// Set photos names for changeComparerPhotos()
function setNames(fileName) {
  const templateUri = $('.js-comparer').data('uri'),
        badOne = $('.js-comparer').children('.bad'),
        goodOne = $('.js-comparer').children('.good'),
        fileExt = 'png',
        filePath = templateUri + '/images/comparer/';

  badOne.attr('src', filePath + fileName + '_bad.' + fileExt);
  goodOne.attr('src', filePath + fileName + '_good.' + fileExt);
}

// Features picker
function featuresPicker() {
  $('.js-features-item').on('mouseenter', function showImage() {
    $('.js-features-target, .js-features-item').removeClass('active');
    $('.js-features-target').eq($(this).index()).addClass('active');
    $(this).addClass('active');
  });
}

// Change text on-hover in comparer
// function changeText() {
//     var textBox = $('.js-dynamic-text'),
//         textBoxDefault = textBox.text(),
//         textBoxNew;
//
//     $('.js-toggle.size--normal').on('mouseenter', function () {
//       textBoxNew = $(this).data('shirt');
//       textBox.text(textBoxNew);
//     });
//
//     $('.js-toggle.size--normal').on('mouseleave', function () {
//       textBox.text(textBoxDefault);
//     });
// }

// Show cart dropdown
function enableCartDdown() {
  $('.cart-ddown, .dropdown-arrow').addClass('active');
}

function disableCartDdown() {
  $('.cart-ddown, .dropdown-arrow').removeClass('active');
}

function openRegionModal() {
  $('.modal-box, .modal-layer').addClass('active');
}

function closeRegionModal() {
  $('.modal-box, .modal-layer').removeClass('active');
}

// Show register form
function showRegisterForm() {
  $('.js-toggle-registration').on('click', function() {
    $('.js-register-toggle').toggleClass('active');
    $('#customer_login').toggleClass('inactive');
  });
}

// Modify site header on scroll
function changeOnScroll() {
  var siteHeader = $('.site-header');

  $(window).on('scroll', function(event){
    var st = $(document).scrollTop();
    if (st > 100){
      $('.site-header').addClass('site-header--smaller');
    } else {
      $('.site-header').removeClass('site-header--smaller');
    }
  });
}

// Sizing chart toggle
function sizingChartToggle() {
  $('.js-sizing-chart').on('click', function () {
    $('.sizing-chart-box').addClass('active');
  });

  $('.sizing-chart-box__close').on('click', function () {
    $('.sizing-chart-box').removeClass('active');
  });
}

// Product variants
function productVariants() {
  // next Steps
  // Click on button
  $('.entry-summary .button').on('click', function () {
    checkAll();

    $(this).parent().find('.choosed').removeClass('choosed');
    $(this).addClass('choosed');
    $(this).parent().next('.inactive').removeClass('inactive');
  });

  // Click on select box
  $('.select-box').on('change', function () {
    var val = $(this).val();

    $(this).addClass('choosed');
    $('.value option[value="'+val+'"]').prop('selected', true).trigger('change');

    $(this).parent().parent().next('.inactive').removeClass('inactive');
  });

  // Change options in hidden WooCommerce select's
  $("div[data-opt]").on('click', function() {
  	var clickedEl = $(this).data('opt');
  	var group = $(this).data('group');
  	var current = $(group).find(':selected');
  	var next = $('.value select option[value*="' + clickedEl + '"]');

  	if ( current !== next) {
  		next.prop('selected', true);
  		next.parent().trigger("change");
  	}
  });
}

// Check if every variant was choosed
function checkAll() {
  var addToCart = $('.single_add_to_cart_button');

  if($('.inactive').length == 0) {
    addToCart.prop('disabled', false);
  }
}

// Changes images on review form according to users choose
function reviewsImagesSwitcher() {

  $('input[name=review-preview], select[name=color], select[name=neck]').on('change', () => {
    switchImage();
  });
  $('.toggle-model-btn').on('click', (event) => {
    event.preventDefault();
    const preview = $('input[name=review-preview]');
    preview.val((preview.val() === 'black') ? preview.attr('data-white') : preview.attr('data-black'));
    preview.trigger('change');
  });
}

function switchImage() {
  const imgChange = $('.js-img-change');
  var preview = $('input[name=review-preview]').val().toLowerCase(),
    color = $('select[name=color]').val().toLowerCase(),
    neck = $('select[name=neck]').val().toLowerCase(),
    srcs = imgChange.data('srcs');

  preview = (preview) ? preview : 'black';
  color = (color) ? color : 'ghost';
  neck = (neck) ? neck : 'crewneck';

  imgChange.attr('src', srcs + preview + '-' + color + '-' + neck + '.webp');
}

//Toggle mobile menu
function mobileMenuToggler() {
  $('.mobile-menu-button').on('click', function () {
    $(this).addClass('active');
    $('.mobile-menu, .mobile-menu-layer').addClass('active');
  });

  $('.mobile-menu-layer').on('click', function () {
    $('.mobile-menu, .mobile-menu-layer, .mobile-menu-button').removeClass('active');
  });
}

// Don't scroll to top
$('.change-regionals a, .js-toggle-registration, .dropdown-arrow, .js-sizing-chart').on('click', function (e) {
  e.preventDefault();
});

const comparer = $('.js-comparer');
if (comparer.length) {
  comparer.twentytwenty();
  comparer.find('.twentytwenty-handle').on('move', (e) => {
    const leftTxt = jQuery('.comparer__compare-text.popular');
    const rightTxt = jQuery('.comparer__compare-text.bro');
    if (e.distX <= 0) {
      leftTxt.removeClass('bigger');
      if (!rightTxt.hasClass('bigger')) {
        rightTxt.addClass('bigger');
      }
    } else {
      rightTxt.removeClass('bigger');
      if (!leftTxt.hasClass('bigger')) {
        leftTxt.addClass('bigger');
      }
    }
  });
}
$('.change-regionals').on('click', function (){ openRegionModal(); });
$('.modal-box__close').on('click', function (){ closeRegionModal(); });
$('.js-show-cart').on('click', function () { enableCartDdown(); });
$('.single_add_to_cart_button').prop('disabled', true);

// changeText();
// changeComparerPhotos();
temporaryComparer();
featuresPicker();
mainMenuToggle();
showRegisterForm();
sizingChartToggle();
checkAll();
productVariants();
mobileMenuToggler();

if ($('.js-review').length) reviewsImagesSwitcher();

if ($(window).innerWidth() > 992) {
  changeOnScroll();
}

// $('.js-accept').on('click', function() {
//   $(this).parent().addClass('out');
//   $.cookie('cookies', 'yes', { expires: 365, path: '/' });
// });

$(document).mouseup(function (e) {
    var container = $(".cart-ddown");

    if (!container.is(e.target)
        && container.has(e.target).length === 0)
    {
        disableCartDdown();
    }
});

// fullpageJS
const containerWithFullpage = $('.container.with-fullpage');
const wpbWrapper = containerWithFullpage.find('.wpb_wrapper');

if (containerWithFullpage.length && wpbWrapper.length) {
  const rows = wpbWrapper.find('.row');

  $('.scroll-please').css('display', 'block');
  const scrollDown = $('.js-scroll-down');

  const numOfSlides = rows.length;

  wpbWrapper.fullpage({
    responsiveWidth: 1000,
    sectionSelector: '.row',
    scrollBar: true,
    // paddingTop: '100px',
    onLeave: function(index, nextIndex, direction) {
      let leavingSlide = $(this);

      if(nextIndex === numOfSlides) {
        scrollDown.addClass('hidden-by-js');
      } else {
        scrollDown.removeClass('hidden-by-js');
      }
    }
  });

  scrollDown.on('click', function () {
    $.fn.fullpage.moveSectionDown();
  });
}

// Fixed to bottom footer element, if site is too small
if ($(window).innerWidth() > 920) {

  window.onload = function () {

    const siteWidth = $(window).innerHeight();
    const footerEl = $('.site-footer');
    const footerBottomPos = footerEl.offset().top + footerEl.innerHeight();

    if(footerBottomPos < siteWidth) {
      footerEl.css({
        position: 'fixed',
        bottom: '0',
        left: '0',
        width: '100%'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/main.js